import { render, staticRenderFns } from "./tagPool.vue?vue&type=template&id=fca2fe88&scoped=true"
import script from "./tagPool.vue?vue&type=script&lang=js"
export * from "./tagPool.vue?vue&type=script&lang=js"
import style0 from "./tagPool.vue?vue&type=style&index=0&id=fca2fe88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca2fe88",
  null
  
)

export default component.exports